module.exports = __webpack_public_path__ + "static/media/Choir3.c2a0fd4d.jpg";